import styled from 'styled-components';

import { RoutalPalette } from '@nx-smartmonkey/ui';
import { useAsUser } from '../../../hooks/session/useAsUser';
import { useRetrieveUserCredentials } from '../../../hooks/user/useRetrieveUserCredentials';
import { SideBarHelp } from './SideBarHelp';
import { SideBarProject } from './SideBarProject';
import { SideBarSections } from './SideBarSections';
import { SideBarUser } from './SideBarUser';
import { SideBarUserSearch } from './SideBarUserSearch';

const SideBarContainer = styled.div`
  width: 62px;
  height: 100%;
  background: ${RoutalPalette.neutral00};
  display: flex;
  flex-direction: column;
  border-right: 1px solid ${RoutalPalette.neutral10};
`;

const BottomContainer = styled.div`
  margin-top: auto;
  margin-bottom: 14px;
`;

const SideBar = () => {
  const { data: userCredentials } = useRetrieveUserCredentials();
  const { asUser } = useAsUser();

  return (
    <SideBarContainer>
      {/* Render Menu Items */}
      <SideBarProject />
      <SideBarSections />

      <BottomContainer>
        <SideBarHelp />
        {userCredentials?.isStaff(asUser) && <SideBarUserSearch />}
        <SideBarUser />
      </BottomContainer>
    </SideBarContainer>
  );
};

export default SideBar;
